<!--
  BotBubble — a single bot message bubble with a small avatar supplied by the consumer.
  `showAvatar` is false for consecutive bot bubbles (only the last in a run shows the
  avatar). Content may contain trusted inline markup (e.g. <strong>) from the consumer's
  own wordings, so it is rendered with v-html — never user input.
-->
<template>
  <div class="msg-row bot-row">
    <img v-if="showAvatar" :src="avatarSrc" class="msg-av" :alt="alt" />
    <div v-else class="av-placeholder" />
    <!-- content is the consumer's own trusted wording, never user input -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="bubble bot-bubble" v-html="content" />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    content: string
    avatarSrc: string
    showAvatar?: boolean
    alt?: string
  }>(),
  { showAvatar: true, alt: '' },
)
</script>

<style scoped>
.msg-row {
  display: flex;
  align-items: flex-end;
  padding: 0 16px;
}
.bot-row {
  gap: 8px;
}
.msg-av {
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
}
.av-placeholder {
  width: 32px;
  flex-shrink: 0;
}
.bubble {
  border-radius: 16px;
  padding: 10px 13px;
  font-size: 13.5px;
  line-height: 1.6;
  max-width: 78%;
}
.bot-bubble {
  background: var(--blue-100);
  border-bottom-left-radius: 4px;
  color: var(--navy-800);
}
.bot-bubble :deep(strong) {
  font-weight: 700;
}
.bot-bubble :deep(a) {
  color: var(--blue-800);
  font-weight: 600;
}
</style>
